import { createFileRoute } from '@tanstack/react-router';
import Companies from '@/features/companies';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/companies')({
  component: CompaniesRoute,
});

function CompaniesRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.CompanyView}>
      <Companies />
    </ProtectedRoute>
  );
} 